/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
'use strict';

const debug = require("debug");
/**
 * Map the given logging level to the debug namespace
 * 
 * @param {String} level Logging level
 * @returns Debug namespace for the logging level
 */


function namespace(level) {
  return `httptransfer:${level}`;
}

module.exports = {
  debug: debug(namespace("debug")),
  info: debug(namespace("info")),
  warn: debug(namespace("warn")),
  error: debug(namespace("error"))
};